import React, {useCallback} from 'react'

import {PointPlacemark} from './point-placemark/PointPlacemark'
import type {Props} from './types'

export const PointClusterPlacemark: React.FC<Props> = props => {
  const {onClick, pointsCount, lnglat, children} = props
  const text = pointsCount > 1 ? (pointsCount > 99 ? '99+' : pointsCount) : null

  const onPointPlacemarkClick = useCallback(() => {
    onClick(lnglat)
  }, [lnglat, onClick])

  return (
    <PointPlacemark coordinates={lnglat} onClick={onPointPlacemarkClick} type="numeric">
      {text ?? children}
    </PointPlacemark>
  )
}
